<template>
  <div>
    <button @click="$router.push('dashboard')" :style="isMobile() ? 'margin-left:80px; margin-bottom: 15px;' : ''" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:25px; padding-left:25px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;">
      <span style="padding-right: 4px;-">←</span> Back to Dashboard
    </button>
    <ModalIdle v-if="isIdle" />
    <b-row>
      <b-col v-if="!isMobile()" cols="2"></b-col>
      <b-col :cols="(isMobile()) ? 12 : 8" style="text-align: center;">
        <p style="font-weight: bold; font-size: 20px; color: black;">Find your order:</p>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" tag="i" class="v-icon notranslate v-theme--light iconify iconify--tabler" width="1em" height="1em" viewBox="0 0 24 24" data-v-e1883507="" style="font-size: 37px; height: 45px; width: 45px; margin-bottom: 3px; margin-right: 0px; padding: 10px; color: black; border-top: solid 1px black; border-radius: 5px 0px 0px 5px; border-bottom: solid 1px black; border-left: solid 1px black;" ><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><circle cx="10" cy="10" r="7"></circle><path d="m21 21l-6-6"></path></g></svg>
        <b-form-input
          id="search_orders"
          v-model="ordersSearch"
          label="text"
          placeholder="Order number or customer PO"
          @keyup.enter="searchOrders()"
          :style="(isMobile()) ? 'width: 75%;' : 'width: 50%;' "
          style="height: 45px; display: inline-block; padding-left: 10px; margin-left: 0px; border-radius: 0px 5px 5px 0px; border-color: black; color"
        ></b-form-input>
        <br v-if="isMobile()">
        <button @click="searchOrders()" style="margin-left: 15px; border: 1px solid black; border-radius: 5px; padding: 10px; padding-left: 20px; padding-right: 20px;">SEARCH</button>
      </b-col>
      <b-col v-if="!isMobile()" cols="2"></b-col>
    </b-row>

    <div v-if="(searchResults.length || searchResults == 'no_results') && !isMobile()" style="background-color: white; color: black; margin-right: 100px; margin-left: 100px; margin-top: 50px; margin-bottom: 50px; padding-bottom: 50px; padding-top: 50px;">
      <p style="padding-left: 50px;  font-weight: bold; font-size: 20px;" :style="(searchResults == 'no_results') ? 'text-align: center;' : '' ">{{ (searchResults == 'no_results') ? 'NO RESULTS' :  'SEARCH RESULTS' }}</p>
      <div v-if="searchResults != 'no_results'">
        <div v-for="(order, index) in searchResults" :key="index" style="color: black; padding-left: 25px; padding-right: 25px; padding-top: 15px; padding-bottom: 15px; background-color: white; min-height: 100px; border: 1px solid black; margin-right: 50px; margin-left: 50px; margin-top: 25px;">
          <b-row style="text-align: center; justify-content: space-between; margin-right: 120px; margin-left: 120px;">
            <div><b>Order #:</b> {{ order.c }}</div>
            <div><b>Order date:</b> {{ order.f }}</div>
            <div><b>PO #:</b> {{ order.d }}</div>
            <div><b>Imprint Name:</b> {{ order.b }}</div>
          </b-row>

          <hr>
          <div @click="openOrderDetails(index)" style="color: black; font-weight: bold; font-size: 18px; cursor: pointer;">Details {{ showOrderDetails === index ? '↓' : '→' }}</div>
          <div v-if="showOrderDetails === index">
            <b-row style="margin-top: 20px; justify-content: space-between !important; margin-right:100px; margin-left: 100px;">
              <div >
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">Order Details:</div>
                <div style="display: flex;">
                  <div style="">
                    <p>Substrate: <br> {{ order.aa }}</p>
                    <p>Size: {{ order.ag }}</p>
                    <p>Handle: {{ order.ab }}</p>
                    <p>Finish: {{ order.ac }}</p>
                  </div>
                  <div style="margin-left: 25px;">
                    <p>GSM: {{ order.af }}</p>
                    <p>Color Count: {{ order.ae }}</p>
                    <p>Case Pack: {{ order.ai }}</p>
                    <p>Cases: {{ order.aj }}</p>
                    <p>Shipping terms/port: {{ order.ax }}</p>
                  </div>
                </div>
              </div>
              <div style="border-left: 1px solid #ebe9f1; margin-bottom: 30px;"></div>
              <div style="">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">Artwork:</div>
                <p>Artwork due date: {{ order.g }}</p>
                <p>Artwork done: {{ order.h }}</p>
                <p>Artwork approved: {{ order.i }}</p>
              </div>
              <div style="border-left: 1px solid #ebe9f1; margin-bottom: 30px;"></div>
              <div style="">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">PPS:</div>
                <p>PPS due date:{{ order.j }}</p>
                <p>ETA PPS: {{ order.k }}</p>
                <p>PPS approval date: {{ order.m }}</p>
              </div>
              <div style="border-left: 1px solid #ebe9f1; margin-bottom: 30px;"></div>
              <div style="">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">Shipping:</div>
                <p>Requested delivery date: {{ order.n }}</p>
                <p>ETD: {{ order.s }}</p>
                <p>ETA: {{ order.u }}</p>
                <p v-if="order.x">Status: <span :style="order.x == 'On time' ? 'color: green;' : 'color: red;' ">{{ order.x }}</span></p>
                <p v-if="order.tracking_or_pro">Tracking or Pro: {{ order.tracking_or_pro }}</p>
              </div>
            </b-row>

          </div>
        </div>
      </div>
    </div>

    <div v-if="(searchResults.length || searchResults == 'no_results') && isMobile()" style="background-color: white; color: black; margin-right: 100px; margin-left: 100px; margin-top: 50px; margin-bottom: 50px; padding-bottom: 50px; padding-top: 50px;">
      <p style="padding-left: 50px;  font-weight: bold; font-size: 20px;" :style="(searchResults == 'no_results') ? 'text-align: center;' : '' ">{{ (searchResults == 'no_results') ? 'NO RESULTS' :  'SEARCH RESULTS' }}</p>
      <div v-if="searchResults != 'no_results'">
        <div v-for="(order, index) in searchResults" :key="index" style="color: black; padding-left: 25px; padding-right: 25px; padding-top: 15px; padding-bottom: 15px; background-color: white; min-height: 100px; border: 1px solid black; margin-right: 50px; margin-left: 50px; margin-top: 25px;">
          <b-row style="text-align: center; justify-content: center;">
            <div><b>Order #:</b> {{ order.c }}</div>
            <div><b>Order date:</b> {{ order.f }}</div>
            <div><b>PO #:</b> {{ order.d }}</div>
            <div><b>Imprint Name:</b> {{ order.b }}</div>
          </b-row>

          <hr>
          <div @click="openOrderDetails(index)" style="color: black; font-weight: bold; font-size: 18px; cursor: pointer;">Details {{ showOrderDetails === index ? '↓' : '→' }}</div>
          <div v-if="showOrderDetails === index">
            <b-row style="margin-top: 10px; justify-content: center !important;">
              <div >
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">Order Details:</div>
                <div style="display: flex;">
                  <div style="">
                    <p>Substrate: <br> {{ order.aa }}</p>
                    <p>Size: {{ order.ag }}</p>
                    <p>Handle: {{ order.ab }}</p>
                    <p>Finish: {{ order.ac }}</p>
                  </div>
                  <div style="margin-left: 25px;">
                    <p>GSM: {{ order.af }}</p>
                    <p>Color Count: {{ order.ae }}</p>
                    <p>Case Pack: {{ order.ai }}</p>
                    <p>Cases: {{ order.aj }}</p>
                    <p>Shipping terms/port: {{ order.ax }}</p>
                  </div>
                </div>
              </div>
              <div style="">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;" v-if="order.g || order.h || order.i">Artwork:</div>
                <p v-if="order.g ">Artwork due date: {{ order.g }}</p>
                <p v-if="order.h">Artwork done: {{ order.h }}</p>
                <p v-if="order.i">Artwork approved: {{ order.i }}</p>
              </div>
              <div style="">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;" v-if="order.j || order.k || order.m">PPS:</div>
                  <p v-if="order.j">PPS due date:{{ order.j }}</p>
                  <p v-if="order.k">ETA PPS: {{ order.k }}</p>
                  <p v-if="order.m">PPS approval date: {{ order.m }}</p>
              </div>

              <div style="text-align: center;">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;" v-if="order.n || order.s || order.t || order.u || order.w  || order.x">Shipping:</div>
                <p v-if="order.n">Requested delivery date: {{ order.n }}</p>
                <p v-if="order.s">ETD: {{ order.s }}</p>
                <p v-if="order.u">ETA: {{ order.u }}</p>
                <p v-if="order.x">Status: <span :style="order.x == 'On time' ? 'color: green;' : 'color: red;' ">{{ order.x }}</span></p>
                <p v-if="order.tracking_or_pro">Tracking or Pro: {{ order.tracking_or_pro }}</p>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <div v-if="(!searchResults.length && searchResults != 'no_results' && orders.length) && !isMobile()" style="background-color: white; color: black; margin-right: 100px; margin-left: 100px; margin-top: 50px; margin-bottom: 50px; padding-bottom: 50px; padding-top: 50px;">
      <p style="padding-left: 50px;  font-weight: bold; font-size: 20px;">ACTIVE ORDERS</p>
      <div>
        <div v-for="(order, index) in orders" :key="index" style="color: black; padding-left: 25px; padding-right: 25px; padding-top: 15px; padding-bottom: 15px; background-color: white; min-height: 100px; border: 1px solid black; margin-right: 50px; margin-left: 50px; margin-top: 25px;">
          <b-row style="text-align: center; justify-content: space-between; margin-right: 120px; margin-left: 120px;">
            <div><b>Order #:</b> {{ order.c }}</div>
            <div><b>Order date:</b> {{ order.f }}</div>
            <div><b>PO #:</b> {{ order.d }}</div>
            <div><b>Imprint Name:</b> {{ order.b }}</div>
          </b-row>

          <hr>
          <div @click="openOrderDetails(index)" style="color: black; font-weight: bold; font-size: 18px; cursor: pointer;">Details {{ showOrderDetails === index ? '↓' : '→' }}</div>
          <div v-if="showOrderDetails === index">
            <b-row style="margin-top: 20px; justify-content: space-between !important; margin-right:50px; margin-left: 50px;">
              <div >
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">Order Details:</div>
                <div style="display: flex;">
                  <div style="">
                    <p>Substrate: <br> {{ order.aa }}</p>
                    <p>Size: {{ order.ag }}</p>
                    <p>Handle: {{ order.ab }}</p>
                    <p>Finish: {{ order.ac }}</p>
                  </div>
                  <div style="margin-left: 25px;">
                    <p>GSM: {{ order.af }}</p>
                    <p>Color Count: {{ order.ae }}</p>
                    <p>Case Pack: {{ order.ai }}</p>
                    <p>Cases: {{ order.aj }}</p>
                    <p>Shipping terms/port: {{ order.ax }}</p>
                  </div>
                </div>
              </div>
              <div style="border-left: 1px solid #ebe9f1; margin-bottom: 30px;"></div>
              <div >
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">Artwork:</div>
                <p>Artwork due date: {{ order.g }}</p>
                <p>Artwork done: {{ order.h }}</p>
                <p>Artwork approved: {{ order.i }}</p>
              </div>
              <div style="border-left: 1px solid #ebe9f1; margin-bottom: 30px;"></div>
              <div style="">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">PPS:</div>
                <p>PPS due date:{{ order.j }}</p>
                <p>ETA PPS: {{ order.k }}</p>
                <p>PPS approval date: {{ order.m }}</p>
              </div>
              <div style="border-left: 1px solid #ebe9f1; margin-bottom: 30px;"></div>
              <div style="">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">Shipping:</div>
                <p>Requested delivery date: {{ order.n }}</p>
                <p>ETD: {{ order.s }}</p>
                <p>ETA: {{ order.u }}</p>
                <p v-if="order.x">Status: <span :style="order.x == 'On time' ? 'color: green;' : 'color: red;' ">{{ order.x }}</span></p>
                <p v-if="order.tracking_or_pro">Tracking or Pro: {{ order.tracking_or_pro }}</p>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <div v-if="(!searchResults.length && searchResults != 'no_results' && orders.length) && isMobile()" style="background-color: white; color: black; margin-top: 50px; margin-bottom: 50px; padding-bottom: 50px; padding-top: 50px;">
      <p style="font-weight: bold; font-size: 20px; text-align: center;">ACTIVE ORDERS</p>
      <div>
        <div v-for="(order, index) in orders" :key="index" style="color: black; padding-left: 25px; padding-right: 25px; padding-top: 15px; padding-bottom: 15px; background-color: white; min-height: 100px; border: 1px solid black; margin-right: 50px; margin-left: 50px; margin-top: 25px;">
          <b-row style="text-align: center; justify-content: center;">
            <div><b>Order #:</b> {{ order.c }}</div>
            <div><b>Order date:</b> {{ order.f }}</div>
            <div><b>PO #:</b> {{ order.d }}</div>
            <div><b>Imprint Name:</b> {{ order.b }}</div>
          </b-row>

          <hr>
          <div @click="openOrderDetails(index)" style="color: black; font-weight: bold; font-size: 18px; cursor: pointer;">Details {{ showOrderDetails === index ? '↓' : '→' }}</div>
          <div v-if="showOrderDetails === index">
            <b-row style="margin-top: 10px; justify-content: center !important;">
              <div >
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">Order Details:</div>
                <div style="display: flex;">
                  <div style="">
                    <p>Substrate: <br> {{ order.aa }}</p>
                    <p>Size: {{ order.ag }}</p>
                    <p>Handle: {{ order.ab }}</p>
                    <p>Finish: {{ order.ac }}</p>
                  </div>
                  <div style="margin-left: 25px;">
                    <p>GSM: {{ order.af }}</p>
                    <p>Color Count: {{ order.ae }}</p>
                    <p>Case Pack: {{ order.ai }}</p>
                    <p>Cases: {{ order.aj }}</p>
                    <p>Shipping terms/port: {{ order.ax }}</p>
                  </div>
                </div>
              </div>
              <div style="">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;" v-if="order.g || order.h || order.i">Artwork:</div>
                  <p v-if="order.g ">Artwork due date: {{ order.g }}</p>
                  <p v-if="order.h">Artwork done: {{ order.h }}</p>
                  <p v-if="order.i">Artwork approved: {{ order.i }}</p>
              </div>
              <div style="">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;" v-if="order.j || order.k || order.m">PPS:</div>
                  <p v-if="order.j">PPS due date:{{ order.j }}</p>
                  <p v-if="order.k">ETA PPS: {{ order.k }}</p>
                  <p v-if="order.m">PPS approval date: {{ order.m }}</p>
              </div>
              <div style="text-align: center;">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;" v-if="order.n || order.s || order.t || order.u || order.w  || order.x">Shipping:</div>
                <p v-if="order.n">Requested delivery date: {{ order.n }}</p>
                <p v-if="order.s">ETD: {{ order.s }}</p>
                <p v-if="order.u">ETA: {{ order.u }}</p>
                <p v-if="order.x">Status: <span :style="order.x == 'On time' ? 'color: green;' : 'color: red;' ">{{ order.x }}</span></p>
                <p v-if="order.tracking_or_pro">Tracking or Pro: {{ order.tracking_or_pro }}</p>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <div v-if="(!searchResults.length && searchResults != 'no_results' && prevOrders.length) && !isMobile()" style="background-color: white; color: black; margin-right: 100px; margin-left: 100px; margin-top: 50px; padding-bottom: 30px; padding-top: 50px;">
      <p @click="enablePrevious()" style="cursor: pointer; padding-left: 50px;  font-weight: bold; font-size: 20px;">PREVIOUS ORDERS {{ showPrevious ? '↓' : '→' }}</p>
      <div v-if="showPrevious" style="padding-bottom: 20px;">
        <div v-for="(order, index) in prevOrders" :key="index" style="color: black; padding-left: 25px; padding-right: 25px; padding-top: 15px; padding-bottom: 15px; background-color: white; min-height: 100px; border: 1px solid black; margin-right: 50px; margin-left: 50px; margin-top: 25px;">
          <b-row style="text-align: center; justify-content: space-between; margin-right: 120px; margin-left: 120px;">
            <div><b>Order #:</b> {{ order.c }}</div>
            <div><b>Order date:</b> {{ order.f }}</div>
            <div><b>PO #:</b> {{ order.d }}</div>
            <div><b>Imprint Name:</b> {{ order.b }}</div>
          </b-row>

          <hr>
          <div @click="openPrevOrderDetails(index)" style="color: black; font-weight: bold; font-size: 18px; cursor: pointer;">Details {{ showPrevOrderDetails == index ? '↓' : '→' }} </div>
          <div v-if="showPrevOrderDetails == index">
            <b-row style="margin-top: 20px; justify-content: space-between !important; margin-right:100px; margin-left: 100px;">
              <div >
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">Order Details:</div>
                <div style="display: flex;">
                  <div style="">
                    <p>Substrate: <br> {{ order.aa }}</p>
                    <p>Size: {{ order.ag }}</p>
                    <p>Handle: {{ order.ab }}</p>
                    <p>Finish: {{ order.ac }}</p>
                  </div>
                  <div style="margin-left: 25px;">
                    <p>GSM: {{ order.af }}</p>
                    <p>Color Count: {{ order.ae }}</p>
                    <p>Case Pack: {{ order.ai }}</p>
                    <p>Cases: {{ order.aj }}</p>
                    <p>Shipping terms/port: {{ order.ax }}</p>
                  </div>
                </div>
              </div>
              <div style="border-left: 1px solid #ebe9f1; margin-bottom: 30px;"></div>
              <div>
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">Artwork:</div>
                <p>Artwork due date: {{ order.g }}</p>
                <p>Artwork done: {{ order.h }}</p>
                <p>Artwork approved: {{ order.i }}</p>
              </div>
              <div style="border-left: 1px solid #ebe9f1; margin-bottom: 30px;"></div>
              <div style="">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">PPS:</div>
                <p>PPS due date:{{ order.j }}</p>
                <p>ETA PPS: {{ order.k }}</p>
                <p>PPS approval date: {{ order.m }}</p>
              </div>
              <div style="border-left: 1px solid #ebe9f1; margin-bottom: 30px;"></div>
              <div style="">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">Shipping:</div>
                <p>Requested delivery date: {{ order.n }}</p>
                <p>ETD: {{ order.s }}</p>
                <p>ETA: {{ order.u }}</p>
                <p v-if="order.x">Status: <span :style="order.x == 'On time' ? 'color: green;' : 'color: red;' ">{{ order.x }}</span></p>
                <p v-if="order.tracking_or_pro">Tracking or Pro: {{ order.tracking_or_pro }}</p>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <div v-if="(!searchResults.length && searchResults != 'no_results' && prevOrders.length) && isMobile()" style="background-color: white; color: black; margin-right: 100px; margin-left: 100px; margin-top: 50px; padding-bottom: 30px; padding-top: 50px;">
      <p @click="enablePrevious()" style="cursor: pointer; padding-left: 50px;  font-weight: bold; font-size: 20px;">PREVIOUS ORDERS {{ showPrevious ? '↓' : '→' }}</p>
      <div v-if="showPrevious" style="padding-bottom: 20px;">
        <div v-for="(order, index) in prevOrders" :key="index" style="color: black; padding-left: 25px; padding-right: 25px; padding-top: 15px; padding-bottom: 15px; background-color: white; min-height: 100px; border: 1px solid black; margin-right: 50px; margin-left: 50px; margin-top: 25px;">
          <b-row style="text-align: center; justify-content: center;">
            <div><b>Order #:</b> {{ order.c }}</div>
            <div><b>Order date:</b> {{ order.f }}</div>
            <div><b>PO #:</b> {{ order.d }}</div>
            <div><b>Imprint Name:</b> {{ order.b }}</div>
          </b-row>

          <hr>
          <div @click="openPrevOrderDetails(index)" style="color: black; font-weight: bold; font-size: 18px; cursor: pointer;">Details {{ showPrevOrderDetails === index ? '↓' : '→' }}</div>
          <div v-if="showPrevOrderDetails === index">
            <b-row style="margin-top: 10px; justify-content: center !important;">
              <div >
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;">Order Details:</div>
                <div style="display: flex;">
                  <div style="">
                    <p>Substrate: <br> {{ order.aa }}</p>
                    <p>Size: {{ order.ag }}</p>
                    <p>Handle: {{ order.ab }}</p>
                    <p>Finish: {{ order.ac }}</p>
                  </div>
                  <div style="margin-left: 25px;">
                    <p>GSM: {{ order.af }}</p>
                    <p>Color Count: {{ order.ae }}</p>
                    <p>Case Pack: {{ order.ai }}</p>
                    <p>Cases: {{ order.aj }}</p>
                    <p>Shipping terms/port: {{ order.ax }}</p>
                  </div>
                </div>
              </div>
              <div style="">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;" v-if="order.g || order.h || order.i">Artwork:</div>
                <p v-if="order.g ">Artwork due date: {{ order.g }}</p>
                <p v-if="order.h">Artwork done: {{ order.h }}</p>
                <p v-if="order.i">Artwork approved: {{ order.i }}</p>
              </div>
              <div style="">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;" v-if="order.j || order.k || order.m">PPS:</div>
                  <p v-if="order.j">PPS due date:{{ order.j }}</p>
                  <p v-if="order.k">ETA PPS: {{ order.k }}</p>
                  <p v-if="order.m">PPS approval date: {{ order.m }}</p>
              </div>
              <div style="text-align: center;">
                <div style="color: black; font-weight: bold; font-size: 20px; text-align: center;" v-if="order.n || order.s || order.t || order.u || order.w  || order.x">Shipping:</div>
                <p v-if="order.n">Requested delivery date: {{ order.n }}</p>
                <p v-if="order.s">ETD: {{ order.s }}</p>
                <p v-if="order.u">ETA: {{ order.u }}</p>
                <p v-if="order.x">Status: <span :style="order.x == 'On time' ? 'color: green;' : 'color: red;' ">{{ order.x }}</span></p>
                <p v-if="order.tracking_or_pro">Tracking or Pro: {{ order.tracking_or_pro }}</p>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import axios from 'axios';
import html2pdf from "html2pdf.js";
import PrintQuote from './PrintQuote.vue'
import ModalIdle from "@/views/components/ModalIdle.vue"
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import { required, email } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    PrintQuote,
    ModalIdle,
  },
  data() {
    return {
      showPrevious: false,
      ordersSearch: '',
      orders: {},
      prevOrders: {},
      showOrderDetails: 0,
      showPrevOrderDetails: 'abcdefg',
      searchResults: [],
    }
  },
  watch: {
    
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    enablePrevious() {
      this.showPrevious = !this.showPrevious
    },
    searchOrders() {
      if (this.ordersSearch.trim() == '') { this.getOrders(this.userData.custPO) }
      let found = false
      for (var i = 0; i<Object.keys(this.orders).length; i++) {
        //console.log('orders: ' + this.orders[i])
        //console.log('comparing: field c: ' + this.orders[i].c + ', searched term: ' + this.ordersSearch.trim() + ', field d: ' + this.orders[i].d)
        if (this.orders[i].c == this.ordersSearch.trim() || this.orders[i].d == this.ordersSearch.trim()) {
          this.searchResults.push(this.orders[i])
          found = true
        }
      }
      if (!found) {
        this.searchResults = 'no_results'
      }
      if (this.ordersSearch == '') {
        this.searchResults = ''
      }

    },
    getOrders(search='') {
      search = (search) ? search : this.ordersSearch

      //axios.defaults.baseURL = ''
      if(this.userData.customer_dis) {
        let url = 'https://flexoapi.online/api/readsheet.php?search='+encodeURIComponent(search) + '&custDis=' + encodeURIComponent(this.userData.customer_dis);
        console.log(url)

        axios
        .get(url)
        .then(response => (this.setOrders(response.data)))
        .catch(function (error) {
          console.log('error: ' + error)
        })
        .finally(function () {

        })
      }
      
    },
    setOrders(res) {
      res = JSON.stringify(res)
      res = JSON.parse(res)
      this.orders = res.open
      this.prevOrders = res.prev
    },
    openOrderDetails(index) {
      this.showOrderDetails = (this.showOrderDetails === index || (this.showOrderDetails === 0 && index === 0)) ? 'abcdefg' : index
    },
    openPrevOrderDetails(index) {
      this.showPrevOrderDetails = (this.showPrevOrderDetails === index || (this.showPrevOrderDetails === 0 && index === 0)) ? 'abcdefg' : index
    },
  },
  mounted() {
    this.userData = JSON.parse(localStorage.getItem('userData'))
    this.getOrders()

  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle
    }
  }
}
</script>
